import { api, HttpError } from "@/lib/http";
import type { FurnitureCategory, GenericItem, Template } from "@/types/api";

async function safe<T>(fn: () => Promise<T>, fallback: T): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    if (e instanceof HttpError && (e.status === 404 || e.status === 405)) return fallback;
    throw e;
  }
}

export const categoriesApi = {
  list: () => api.get<FurnitureCategory[]>("/api/categories"),
};

export const templatesApi = {
  list: () => safe(() => api.get<Template[]>("/api/templates"), []),
  rename: (id: number, name: string) => api.put<Template>(`/api/templates/${id}`, { name }),
  remove: (id: number) => api.del<void>(`/api/templates/${id}`),
  create: (name: string) => api.post<Template>("/api/templates", { name }),
  listPlaceholders: (templateId: number) =>
    safe(() => api.get<GenericItem[]>(`/api/templates/${templateId}/items`), []),
  upsertPlaceholder: (templateId: number, item: Partial<GenericItem>) =>
    item.id
      ? api.put<GenericItem>(`/api/templates/${templateId}/items/${item.id}`, item)
      : api.post<GenericItem>(`/api/templates/${templateId}/items`, item),
  removePlaceholder: (templateId: number, itemId: number) =>
    api.del<void>(`/api/templates/${templateId}/items/${itemId}`),
};
